"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Footer_1 = __importDefault(require("../../components/Footer"));
var Header_1 = __importDefault(require("../../components/Header"));
var WhatsAppFloatingButton_1 = require("../../components/WhatsAppFloatingButton");
var Toast_1 = require("../../components/Toast");
function Layout(_a) {
    var children = _a.children, _b = _a.noFooter, noFooter = _b === void 0 ? false : _b, _c = _a.withBackground, withBackground = _c === void 0 ? false : _c, rest = __rest(_a, ["children", "noFooter", "withBackground"]);
    var mainRef = (0, react_1.useRef)(null);
    function onClickToTop() {
        var _a;
        (_a = mainRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("main", __assign({ ref: mainRef }, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, { withBackground: withBackground }), children, !noFooter && (0, jsx_runtime_1.jsx)(Footer_1.default, { onClickToTop: onClickToTop })] })), (0, jsx_runtime_1.jsx)(WhatsAppFloatingButton_1.WhatsAppFloatingButton, {}), (0, jsx_runtime_1.jsx)(Toast_1.ToastContainer, {})] }));
}
exports.default = (0, react_1.memo)(Layout);
